import AmexIcon from "../../../../assets/icons/cards/Amex.svg";
import DinersClubIcon from "../../../../assets/icons/cards/DinersClub.svg";
import DiscoverIcon from "../../../../assets/icons/cards/Discover.svg";
import JCBIcon from "../../../../assets/icons/cards/JCB.svg";
import MastercardIcon from "../../../../assets/icons/cards/Mastercard.svg";
import UnionPayIcon from "../../../../assets/icons/cards/UnionPay.svg";
import VisaIcon from "../../../../assets/icons/cards/Visa.svg";

export const CARD_ICONS = [
    { src: VisaIcon, alt: 'Visa' },
    { src: DinersClubIcon, alt: 'Diners Club' },
    { src: AmexIcon, alt: 'American Express' },
    { src: UnionPayIcon, alt: 'UnionPay' },
    { src: MastercardIcon, alt: 'Mastercard' },
    { src: JCBIcon, alt: 'JCB' },
    { src: DiscoverIcon, alt: 'Discover' },
] as const;

export const MOBILE_CARD_ICONS = [
    { src: AmexIcon, alt: 'Amex' },
    { src: VisaIcon, alt: 'Visa' },
    { src: MastercardIcon, alt: 'Mastercard' },
] as const;

export const STRIPE_ELEMENT_OPTIONS = {
    hideIcon: false,
    disableLink: true,
    style: {
        base: {
            fontSize: '16px',
            fontWeight: '400',
            color: '#424770',
            fontFamily: 'Nano Sans, sans-serif',
            '::placeholder': {
                color: '#aab7c4',
            },
        },
        invalid: {
            color: '#fa755a',
        },
    },
} as const;

export const STRIPE_FIELDS = {
    CARD_NUMBER: 'cardNumber',
    EXPIRY_DATE: 'expiryDate',
    SECURITY_CODE: 'securityCode',
} as const;
